import { useMutation } from '@apollo/client';
import { Button } from 'antd';
import CircularProgress from 'components/CircularProgress/index';
import { InputComponent } from 'components/common/Input';
import { ICommonBothTypeInputProps, INPUT_TYPE, LABEL_TYPE } from 'components/common/Input/types';
import ErrorContainer from 'components/ErrorContainer';
import { Form, Formik } from 'formik';
import React, { useEffect } from 'react';
// import SweetAlert from 'react-bootstrap-sweetalert';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { AuthAction } from 'redux/actions';
import { RootState } from 'redux/types';
import ROUTES from 'routes/routeConstants';
import { ActionButtonContainer, OrTextContainerStyled } from 'routes/SignIn/components/styled';
import { SIGN_UP_USER } from 'services/graphql/mutations/users';
import { UserSignupPayload, UserStatusEnum } from 'types/user';
import { defaultNotification } from 'utils';
import IntlMessages from 'utils/IntlMessages';
import * as Yup from 'yup';

const signUpFields = [
  { type: INPUT_TYPE.TEXT, name: 'firstName', label: 'First Name' },
  { type: INPUT_TYPE.TEXT, name: 'lastName', label: 'Last Name' },
  { type: INPUT_TYPE.PASSWORD, name: 'password', label: 'Password' },
  { type: INPUT_TYPE.PASSWORD, name: 'reEnterPassword', label: 'Re-enter password' },
];

const SignUpSchema = Yup.object({
  firstName: Yup.string().required('Required'),
  lastName: Yup.string().required('Required'),
  password: Yup.string().required('Required'),
  reEnterPassword: Yup.string()
    .required('Required')
    .oneOf([Yup.ref('password'), null], 'Passwords must match'),
});

const SignUp: React.FC<{ token: string; userData: Record<string, any> }> = ({ token, userData }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { accessToken, expires } = useSelector<RootState, RootState['auth']>(({ auth }) => auth);

  const [signUpUser, { loading, error }] = useMutation(SIGN_UP_USER);
  // const [isShowSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (accessToken && expires > Date.now()) {
      history.push('/');
    }
  }, [accessToken && expires]);

  // const onConfirmSuccess = () => { };

  const onFinish = async ({ firstName, lastName, password }: UserSignupPayload) => {
    try {
      const response = await signUpUser({
        variables: {
          updatedDoc: {
            firstName,
            lastName,
            password,
            status: UserStatusEnum.REGISTERED,
          },
          token,
        },
      });

      if (response) {
        dispatch(
          AuthAction.userSignIn({
            email: response.data?.signUpUserEntity?.email,
            password,
            rememberMe: true,
            callback: {
              callbackOnFailure: () => {
                history.push(ROUTES.SIGN_IN);
              },
            },
          }),
        );
      }
    } catch (err) {
      // Ignore
      defaultNotification({ failure: 'Something went wrong! Please try again.' });
    }
  };

  const renderInput = (field: ICommonBothTypeInputProps) => (
    <InputComponent
      key={field.name}
      label={field.label}
      type={field.type}
      name={field.name}
      labelType={LABEL_TYPE.above}
    />
  );

  return (
    <>
      <div className='gx-app-login-content'>
        <Formik
          initialValues={{ firstName: userData.firstName || '', lastName: userData.lastName || '', password: '' }}
          name='basic'
          onSubmit={onFinish}
          validationSchema={SignUpSchema}
          validateOnBlur>
          <Form className='gx-signin-form gx-form-row0'>
            {signUpFields.map((field) => renderInput(field))}
            {!!error?.message && (
              <ErrorContainer>
                <span>{error?.message || ''}</span>
              </ErrorContainer>
            )}
            <ActionButtonContainer marginTop='25px'>
              <Button type='primary' loading={loading} className='gx-mb-0' htmlType='submit'>
                <IntlMessages id='app.userAuth.signUp' />
              </Button>
              <OrTextContainerStyled>
                <IntlMessages id='app.userAuth.or' />
              </OrTextContainerStyled>
              <Link to={ROUTES.SIGN_IN}>
                <IntlMessages id='app.userAuth.signIn' />
              </Link>
            </ActionButtonContainer>
            {/* <div className='gx-flex-row gx-justify-content-between'>
                  <span>or connect with</span>
                  <ul className='gx-social-link'>
                    <li>
                      <GoogleOutlined onClick={() => {}} />
                    </li>
                    <li>
                      <FacebookOutlined onClick={() => {}} />
                    </li>
                    <li>
                      <GithubOutlined onClick={() => {}} />
                    </li>
                    <li>
                      <TwitterOutlined onClick={() => {}} />
                    </li>
                  </ul>
                </div>
                <span className='gx-text-light gx-fs-sm'>
                  {' '}
                  demo user email: &apos;demo@example.com&apos; and password: &apos;demo#123&apos;
                </span> */}
          </Form>
        </Formik>
      </div>
      {/* <SweetAlert
        show={isShowSuccess}
        success
        title={<IntlMessages id='createAccountSuccess.title' />}
        onConfirm={onConfirmSuccess}>
        <IntlMessages id='createAccountSuccess.content' />
      </SweetAlert> */}
      {loading && (
        <div className='gx-loader-view'>
          <CircularProgress />
        </div>
      )}
    </>
  );
};

export default SignUp;
